<template>
  <div class="system-params">
    <el-row>
      <el-col :span="12">
        Api地址:
        <el-input
          style="width: 250px"
          size="small"
          v-model="childrenData.apiAddr"
        ></el-input>
      </el-col>
    </el-row>
    <span class="btn">
      <el-button size="small" type="warning" @click="reset">{{
        $t("app.reset")
      }}</el-button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    childrenData: {
      type: Object,
      default() {
        return {
          apiAddr: "",
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    reset() {
      this.childrenData.apiAddr = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.system-params {
  min-height: 100px;
  padding-bottom: 50px;
  .el-row {
    .el-col {
      margin-bottom: 15px;
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>
